<template>
  <div class="flex lg:flex-1 max-w-[100px] sm:max-w-[160px]">
    <NuxtLink to="/" class="-m-1.5 p-1.5">
      <img
        class="z-[1] object-fill max-w-full hidden dark:block"
        width="702px"
        height="303px"
        src="~/assets/images/logo-dark.svg"
        alt=""
      />
      <img
        class="z-[1] object-fill max-w-full block dark:hidden"
        width="702px"
        height="303px"
        src="~/assets/images/logo-light.svg"
        alt=""
      />
    </NuxtLink>
  </div>
</template>
